import { render, staticRenderFns } from "./TreeRatificacionesDigital.vue?vue&type=template&id=5a4bbc4d&scoped=true"
import script from "./TreeRatificacionesDigital.vue?vue&type=script&lang=js"
export * from "./TreeRatificacionesDigital.vue?vue&type=script&lang=js"
import style0 from "./TreeRatificacionesDigital.vue?vue&type=style&index=0&id=5a4bbc4d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4bbc4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a4bbc4d')) {
      api.createRecord('5a4bbc4d', component.options)
    } else {
      api.reload('5a4bbc4d', component.options)
    }
    module.hot.accept("./TreeRatificacionesDigital.vue?vue&type=template&id=5a4bbc4d&scoped=true", function () {
      api.rerender('5a4bbc4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificacionesdigital/TreeRatificacionesDigital.vue"
export default component.exports